"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M344.2 104.2c40.9 0 72.9 32 72.9 72.9 0 60.1-65.1 119.3-163.7 208.8l-.7.7-2.2 2-2.6-2.4C149.1 296.5 83.8 237.3 83.8 177.1c0-40.9 32-72.9 72.9-72.9 52.1 0 93.8 57 93.8 57s40.4-57 93.7-57m0-41.7c-36.2 0-71 16.9-93.8 43.5-36.6-43-104.6-60.5-159.5-23-29.3 20-47.5 53.9-48.8 89.4-2.8 80.9 68.6 145.7 178 244.9l16.2 14.8c7.9 7.2 20 7.2 28 .1l16.2-14.6C388 320 458.8 255.8 458.8 177.1c0-64.2-50.4-114.6-114.6-114.6z"
  });
};

exports.default = _default;